//@ts-ignore
import { tw } from "@careinfo/tailwind";

const TextField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    type = "text",
    errors,
    label,
    ...otherAttributes
  } = props;

  return (
    <>
      <div
        className={tw`w-full my-2 text-left mt-4 ${otherAttributes.className}`}
      >
        <label htmlFor="">{label}</label>
        {type === "textarea" ? (
          <textarea
            {...otherAttributes}
            {...register}
            placeholder={placeholder}
            defaultValue={value}
            type={type}
            className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1 ${otherAttributes.inputWrapper}`}
          ></textarea>
        ) : (
          <input
            {...otherAttributes}
            {...register}
            placeholder={placeholder}
            defaultValue={value}
            type={type}
            className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1 ${otherAttributes.inputWrapper}`}
          />
        )}
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default TextField;
